import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';

import * as S from './styled';

const LoadedImages = new Map();

function useLoadedImagesCache(src) {
  const [isLoaded, setIsLoaded] = useState(LoadedImages.has(src));

  const setLoaded = () => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    LoadedImages.set(src, true);
  };

  return [isLoaded, setLoaded];
}

const UserAvatar = ({
  size,
  src,
  visibleByDefault,
  isLoading,
  isSelected,
  onlineStatus,
  initials,
}) => {
  const [isLoaded, setLoaded] = useLoadedImagesCache(visibleByDefault || src);

  useEffect(() => {
    if (!visibleByDefault && !isLoaded && src) {
      const avatarImg = new Image();
      avatarImg.onload = () => {
        setLoaded();
      };
      avatarImg.src = src;
    }
  }, [isLoaded, src, visibleByDefault]);

  return (
    <S.AvatarFrame size={size}>
      {src ? (
        <S.Avatar
          src={src}
          isLoaded={isLoaded}
        />
      ) : (
        <S.AvatarInitials isLoading={isLoading}>{initials}</S.AvatarInitials>
      )}
      {onlineStatus && (
        <Tooltip title={onlineStatus}>
          <S.OnlineIdicator
            status={onlineStatus}
            size={size}
          />
        </Tooltip>
      )}
      {isSelected && <S.SelectedMark size={size} />}
    </S.AvatarFrame>
  );
};

UserAvatar.propTypes = {
  size: PropTypes.string.isRequired,
  src: PropTypes.string,
  initials: PropTypes.string,
  onlineStatus: PropTypes.string,
  visibleByDefault: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSelected: PropTypes.bool,
};
UserAvatar.defaultProps = {
  onlineStatus: null,
  initials: null,
  visibleByDefault: false,
  isLoading: false,
  isSelected: false,
};
export const { sizes } = S;

export default UserAvatar;
